import React from 'react';
import Navbar from '../components/Navbar';
import EcoFriendlySection from '../components/EcoFriendlySection.js';
import "../styles/ecoPage.css";

const EcoPage = () => {
  return (
    <div className="eco-page">
      <Navbar />
      {/* Hero Section for Eco Page */}
      <section className="eco-page-hero">
        <div className="eco-hero-content">
          <h1 className="eco-hero-title">SUSTAINABLE LANDSCAPING SOLUTIONS</h1>
          <p className="eco-hero-subtitle">
            Protecting Idaho's Natural Beauty While Enhancing Your Property
          </p>
        </div>
      </section>

      {/* Main Eco-Friendly Section - Full Layout */}
      <EcoFriendlySection 
        layout="full"
        showTitle={true}
        showCTA={true}
        variant="light"
        context="residential"
      />

      {/* Additional Eco Content Section */}
      <section className="eco-commitment-section">
        <div className="container">
          <h2 className="section-title">OUR ENVIRONMENTAL COMMITMENT</h2>
          <div className="commitment-grid">
            <div className="commitment-card">
              <h3>Local Ecosystem Protection</h3>
              <p>We prioritize native Idaho plants and sustainable practices that support local wildlife and preserve natural habitats.</p>
            </div>
            <div className="commitment-card">
              <h3>Resource Conservation</h3>
              <p>Our water-wise landscaping techniques and efficient equipment usage minimize environmental impact while maximizing results.</p>
            </div>
            <div className="commitment-card">
              <h3>Community Partnership</h3>
              <p>We work with local environmental organizations to stay current on best practices and contribute to Idaho's sustainability efforts.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EcoPage;